import { REG_TYPES, RACE_TYPES } from './Store';

const Reducer = (state, action) => {
	switch (action.type) {
		case 'INCREASE_CURRENT_STEP':
			return {
				...state,
				currentStep: state.currentStep + 1,
			};
		case 'SET_CURRENT_STEP_TO_ZERO':
			return {
				...state,
				currentStep: 0,
			};
		case 'SHOW_COOKIE_OVERLAY':
			return {
				...state,
				showCookieOverlay: true,
			};
		case 'HIDE_COOKIE_OVERLAY':
			return {
				...state,
				showCookieOverlay: false,
			};
		case 'SET_REG_TO_IPP':
			return {
				...state,
				regType: REG_TYPES.IPP,
			};
		case 'ACCEPT_THIRD_PARTY_TRACKING':
			return {
				...state,
				thirdPartyTrackingAccepted: true,
			};
		case 'REJECT_THIRD_PARTY_TRACKING':
			return {
				...state,
				thirdPartyTrackingAccepted: false,
			};
		case 'MARK_TRACKING_EXECUTED':
			return {
				...state,
				trackingExecuted: true,
			};
		case 'SET_RACE_TO_HUMANS':
			return {
				...state,
				race: RACE_TYPES.HUMANS,
			};
		case 'SET_RACE_TO_ELVES':
			return {
				...state,
				race: RACE_TYPES.ELVES,
			};
		case 'SHOW_RACE_SELECTION':
			return {
				...state,
				showRaceSelection: true,
			};
		case 'HIDE_RACE_SELECTION':
			return {
				...state,
				showRaceSelection: false,
			};
		case 'START_BACKGROUND_MUSIC':
			return {
				...state,
				backgroundMusicPlaying: true,
			};
		case 'STOP_BACKGROUND_MUSIC':
			return {
				...state,
				backgroundMusicPlaying: false,
			};
		case 'SHOW_SERVER_ERROR':
			return {
				...state,
				showServerError: true,
			};
		case 'HIDE_SERVER_ERROR':
			return {
				...state,
				showServerError: false,
			};
		case 'SET_SERVER_ERROR_MESSAGE':
			return {
				...state,
				serverErrorMessage: action.payload,
			};
		case 'SHOW_SERVER_SUCCESS':
			return {
				...state,
				showServerSuccess: true,
			};
		case 'HIDE_SERVER_SUCCESS':
			return {
				...state,
				showServerSuccess: false,
			};
		case 'SET_SERVER_SUCCESS_MESSAGE':
			return {
				...state,
				serverSuccessMessage: action.payload,
			};
		case 'INITIALIZE_PORTAL_BAR':
			return {
				...state,
				portalBarInitialized: true,
			};
		case 'MARK_PORTAL_BAR_HTML_LOADED':
			return {
				...state,
				portalBarHTMLLoaded: true,
			};
		case 'SHOW_REMEMBERME_MODAL':
			return {
				...state,
				showRememberMeModal: true,
			};
		case 'HIDE_REMEMBERME_MODAL':
			return {
				...state,
				showRememberMeModal: false,
			};
		case 'SET_REMEMBER_USER':
			return {
				...state,
				rememberMe: action.payload,
			};
		case 'TOGGLE_REMEMBER_USER':
			return {
				...state,
				rememberMe: !state.rememberMe,
			};
		case 'TRANSLATIONS_LOADED':
			return {
				...state,
				translationsLoaded: true,
			};
		case 'SHOW_FORGOTPW_OVERLAY':
			return {
				...state,
				showForgotPWOverlay: true,
			};
		case 'HIDE_FORGOTPW_OVERLAY':
			return {
				...state,
				showForgotPWOverlay: false,
			};
		case 'SET_SERVER_MESSAGES':
			return {
				...state,
				serverMessages: action.payload,
			};
		case 'SET_SITE_LANGUAGE':
			return {
				...state,
				language: action.payload,
			};
		case 'SET_PRIVACY_URL':
			return {
				...state,
				privacyUrl: action.payload,
			};
		case 'SET_TERMS_AND_CONDITIONS_URL':
			return {
				...state,
				termsAndConditionsUrl: action.payload,
			};
		case 'SET_IMPRINT_URL':
			return {
				...state,
				imprintUrl: action.payload,
			};
		case 'ENABLE_LOGIN_INPUTS':
			return {
				...state,
				loginInputsDisabled: false,
			};
		case 'SET_LOCALE':
			return {
				...state,
				locale: action.payload,
			};
		case 'SET_IPP_LINK':
			return {
				...state,
				ippLink: action.payload,
			};
		case 'SHOW_LOGIN_HUB_FORM_SUCCESS':
			return {
				...state,
				showLoginHubFormSuccess: true,
			};
		case 'HIDE_LOGIN_HUB_FORM_SUCCESS':
			return {
				...state,
				showLoginHubFormSuccess: false,
			};
		case 'SET_PLAYER_ID':
			return {
				...state,
				playerId: action.payload,
			};
		case 'SET_LPS_TOKEN':
			return {
				...state,
				lpsToken: action.payload,
			};
		case 'SET_PRE_LANDER_STEP':
			return {
				...state,
				preLanderStep: action.payload,
			};
		case 'COMPLETE_PRE_LANDER':
			return {
				...state,
				preLanderCompleted: true,
			};
		case 'RESET_PRE_LANDER':
			return {
				...state,
				preLanderStep: 1,
				preLanderCompleted: false,
			};
		case 'SET_ONETIME_SIGN_IN_URL':
			return {
				...state,
				oneTimeLoginUrl: action.payload
			};
		default:
			return state;
	}
};

export default Reducer;
